import fetch from './fetch'

export default {
  getGeneralCounts (payload) {
    let request = fetch({
      url: `/statistics/general-counts`,
      method: 'get',
      payload
    })
    return request.call()
  },
  getPersonCountsByTime (payload) {
    let request = fetch({
      url: `/statistics/person-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentCountsByTime (payload) {
    let request = fetch({
      url: `/statistics/assessment-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentIndicatorsByPerson (payload) {
    let request = fetch({
      url: `/statistics/assessment/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getCseitIndicatorsByPerson (payload) {
    let request = fetch({
      url: `/statistics/cseit/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getCseitCountsByTime (payload) {
    let request = fetch({
      url: `/statistics/cseit-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningCountsByTime (payload) {
    let request = fetch({
      url: `/statistics/laborscreening-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentIndicators (payload) {
    let request = fetch({
      url: `/statistics/assessment/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getPersonCountsByDemographic (payload) {
    let request = fetch({
      url: `/statistics/person-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentsByLocationForMap (payload) {
    let request = fetch({
      url: `/statistics/geography/assessment-by-location`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getPersonDemographicsOverTime (payload) {
    let request = fetch({
      url: `/statistics/person-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getCseitCountsByDemographic (payload) {
    let request = fetch({
      url: `/statistics/cseit-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningCountsByDemographic (payload) {
    let request = fetch({
      url: `/statistics/laborscreening-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentCountsByDemographic (payload) {
    let request = fetch({
      url: `/statistics/assessment-by-demographics`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getAssessmentDemographicsOverTime (payload) {
    let request = fetch({
      url: `/statistics/assessment-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getCseitDemographicsByTime (payload) {
    let request = fetch({
      url: `/statistics/cseit-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningDemographicsByTime (payload) {
    let request = fetch({
      url: `/statistics/laborscreening-by-demographics-by-time`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getCseitIndicators (payload) {
    let request = fetch({
      url: `/statistics/cseit/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningIndicators (payload) {
    let request = fetch({
      url: `/statistics/laborscreening/indicators`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getScreeningsByOrg (payload) {
    let request = fetch({
      url: `/statistics/screenings-by-org`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getLaborScreeningsByOrg (payload) {
    let request = fetch({
      url: `/statistics/laborscreenings-by-org`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/statistics.js